// 第三方
import * as React from "react";
import { observer } from "mobx-react";
// UI
import { Container, Content, Expired, Num, BoxSymbol } from "./styles";
// 组件
import NextImage from "views/components/NextImage";
// utils
import { getLitbLangFn } from "utils/language/index";
import {
  endUnit,
  EnFormateDays,
  formatDate,
  formatMinutesAndSeconds,
} from "utils/time";
// typings
import { CountdownStore } from "./store";
import {
  TModuleWithImgProps,
  TCountdownModule,
} from "../../../services/playground";
import { TActState, TBannerItem } from "../../../services/banner";
import { formatAspect } from "utils/playground/banner";
import { isUnValidState, isValidState } from "views/utils/banner";

export interface CountdownBannerMod {
  banner: TBannerItem;
  actState: TActState;
  timer: TCountdownModule;
}
interface CountdownBannerProps extends TModuleWithImgProps {
  banner: TBannerItem;
  actState: TActState;
  timer: TCountdownModule;
  onRefresh: () => Promise<CountdownBannerMod>;
}

@observer
export default class MCountdownBanner extends React.Component<CountdownBannerProps> {
  store: CountdownStore;
  constructor(props: CountdownBannerProps | Readonly<CountdownBannerProps>) {
    super(props);
    this.store = new CountdownStore(
      props.actState,
      props.timer,
      props.onRefresh
    );
  }

  componentWillUnmount() {
    clearInterval(this.store.intervalId);
  }

  get title() {
    const { state, timer, countDown } = this.store;
    const { language } = this.props;
    switch (state) {
      case TActState.ComingSoon:
        return `${getLitbLangFn("Starts On", language)} ${formatDate(
          parseInt(timer?.start, 10) * 1000,
          language
        )}`;
      case TActState.OnGoing:
        return `Ends In ${EnFormateDays(countDown)} ${endUnit(language)}`;
      default:
        return `${getLitbLangFn(
          "We‘re sorry，the offer has expired.",
          language
        )}`;
    }
  }

  render() {
    const { positionId, banner, placeholderBg, moduleIndex } = this.props;
    const { state, countDown } = this.store;
    const validBannerStatus = isValidState(state);
    const bannerHeight =
      banner.height && validBannerStatus ? banner.height : "auto";
    const width = formatAspect(banner.width || "");
    return (
      <section data-id={positionId} id={positionId}>
        <Container style={{ height: `${bannerHeight}` }}>
          {isUnValidState(state) && <Expired>{this.title}</Expired>}
          {validBannerStatus && (
            <React.Fragment>
              <NextImage
                src={banner?.img}
                online={true}
                qnParams={{ w: Math.max(width, 750) }}
                placeholder={placeholderBg}
                fallbackSrc={placeholderBg}
                style={{
                  width: "100%",
                  height: bannerHeight,
                }}
                layoutFill={true}
                moduleIndex={moduleIndex}
                alt=""
              />
              <Content>
                <h1>{this.title}</h1>
                <div>
                  {formatMinutesAndSeconds(countDown, state).map(
                    (item, index) => {
                      return (
                        <React.Fragment key={`${index}`}>
                          {item.split("").map((i, idx) => (
                            <Num key={`${idx}_${i}`}>{i}</Num>
                          ))}
                          {!!(index < 2) && <BoxSymbol>:</BoxSymbol>}
                        </React.Fragment>
                      );
                    }
                  )}
                </div>
              </Content>
            </React.Fragment>
          )}
        </Container>
      </section>
    );
  }
}
